// Added by Jonghyung Lee on 2021-01-14
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export interface NotificationItem {
  id: string
  fk_user_id: string
  message: string
  source: string
  read: boolean
  created_at: string
  updated_at: string
}

export interface ReqGetNotifications {
  filter?: string
  page_index?: number
  page_size?: number
  order_by?: string
  [key: string]: string | string[] | number | undefined
}

/** Maximum notistack couunt */
export const MAX_NOTI_COUNT = 3

/** default duration for notistack */
export const NOTI_AUTO_HIDE_DURATION = 3000

/** Notification center용 custom snackbar를 띄우기 위한 key */ 
export const FROM_NOTI_CENTER = 'from-notification-center'

/** Notification center의 반복 체크 주기 10초 */ 
export const INTERVAL_FETCH_TIME = 10000

/** Notification popup 유지시간 */
export const NOTIFICATION_AUTO_HIDE_DURATION = 7000

/** Notification Page size */
export const PAGE_SIZE = 30
